module.exports = __webpack_public_path__ + "static/media/calendar-green.b7cf058f.svg";